import styled from "styled-components";
import { theme } from "../Theme";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import LazyLoad from "react-lazyload";

Modal.setAppElement("#root");

const ProjectPreview = ({ project, onClose, isMobile }) => {
	return (
		<HoveredProjectContainer
			key={project.title}
			style={
				isMobile
					? {
							top: "70px",
							left: "50%",
							transform: "translateX(-50%)",
							height: "600px",
						}
					: { left: "30%", top: "140px" }
			}
		>
			{project.images?.length > 0 && project.images[0]?.url && (
				<LazyLoad>
					<Image
						src={project.images[0].url}
						alt={project.images[0].altText || "Preview image"}
					/>
				</LazyLoad>
			)}
			{project.video && (
				<ResponsivePlayerWrapper>
					<ReactPlayer
						url={project.video}
						playing
						loop
						muted
						playsinline
						controls={false}
						width="100%"
						height="auto"
						style={{ borderRadius: "8px" }}
						config={{
							file: {
								attributes: {
									playsInline: true,
									controls: false,
									muted: true,
									autoPlay: true,
								},
							},
						}}
					/>
				</ResponsivePlayerWrapper>
			)}

			{project.description && (
				<>
					{isMobile && <CloseButton onClick={onClose}>×</CloseButton>}
					<Description>{project.description}</Description>
				</>
			)}
		</HoveredProjectContainer>
	);
};

export default ProjectPreview;

const HoveredProjectContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	color: var(--v2);
	background-color: var(--v1);
	padding: 25px 10px;
	border-radius: 10px;
	position: fixed;
	top: 0;
	z-index: 100;
	pointer-events: auto;
	width: min(900px, 90vw);
	height: auto;
	max-width: 1000px;
	flex-wrap: nowrap;
	animation: myAnim 0.4s ease 0s 1 normal forwards;

	@keyframes myAnim {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@media (max-width: ${theme.breakpoints.md}) {
		width: min(750px, 92vw);
		left: 50%;
		transform: translateX(-50%);
		top: 200px;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		flex-direction: column;
		width: 92vw;
		height: auto;
		left: 50%;
		transform: translateX(-50%);
		top: 70px;
	}
`;

const Description = styled.p`
	padding: 10px;
	font-family: "Poppins", sans-serif;
	font-size: clamp(11px, 1.1vw, 15px);
	text-align: start;
	line-height: 1.6;
	min-width: 0;

	@media (max-width: ${theme.breakpoints.sm}) {
		font-size: clamp(12px, 3vw, 14px);
	}
`;

const Image = styled.img`
	width: 100%;
	height: 100%;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
	margin: 0 10px;
	object-fit: cover;
	flex-shrink: 0;
	padding: 20px;

	@media (max-width: ${theme.breakpoints.md}) {
		width: 45%;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		width: 100%;
		margin: 0 0 10px 0;
	}
`;

const ResponsivePlayerWrapper = styled.div`
	width: 50%;
	height: auto;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
	margin: 0 10px;
	flex-shrink: 0;
	overflow: hidden;

	> div {
		width: 100% !important;
		height: 100% !important;
	}

	video {
		width: 100%;
		height: auto;
		object-fit: cover;
	}

	@media (max-width: ${theme.breakpoints.md}) {
		width: 45%;
	}

	@media (max-width: ${theme.breakpoints.sm}) {
		width: 100%;
		margin: 0 0 10px 0;
	}
`;

const CloseButton = styled.button`
	position: absolute;
	top: 10px;
	right: 10px;
	background: transparent;
	border: none;
	font-size: 20px;
	cursor: pointer;
	color: var(--v2);
`;
